module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_data01-sp-d9a1c754f5eeffb0549b1e74d488329a.png";